module.exports = "<div class=\"card\">\n\n  <div class=\"container\">\n    <p><b> Data is Uploading wait for sometime.......</b></p>\n  </div>\n</div>"